import React from 'react';
import { Alert, Button, Box } from '@mui/material';
import { ConfirmationNumber } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const LOW_TOKEN_THRESHOLD = 15;

const TokenWarning: React.FC = () => {
  const { tokenBalance } = useAuth();
  const navigate = useNavigate();

  if (tokenBalance >= LOW_TOKEN_THRESHOLD) return null;

  const isZero = tokenBalance <= 0;

  return (
    <Alert
      severity={isZero ? 'error' : 'warning'}
      icon={<ConfirmationNumber />}
      sx={{
        mb: 2,
        backgroundColor: isZero
          ? 'rgba(192,57,43,0.08)'
          : 'rgba(232,160,69,0.1)',
        border: `1px solid ${isZero ? 'rgba(192,57,43,0.3)' : 'rgba(232,160,69,0.3)'}`,
        '& .MuiAlert-icon': {
          color: isZero ? '#C0392B' : '#E8A045',
        },
      }}
      action={
        <Button
          size="small"
          onClick={() => navigate('/pricing')}
          sx={{
            color: isZero ? '#C0392B' : '#E8A045',
            fontWeight: 600,
            textTransform: 'none',
            borderColor: isZero ? 'rgba(192,57,43,0.4)' : 'rgba(232,160,69,0.4)',
          }}
          variant="outlined"
        >
          Get Tokens
        </Button>
      }
    >
      <Box>
        {isZero
          ? 'You\'re out of tokens. AI features (strategy creation, backtesting, recommendations) are paused.'
          : `Low token balance (${tokenBalance} remaining). Some actions like backtesting (25 tokens) may fail.`}
      </Box>
    </Alert>
  );
};

export default TokenWarning;
